var _defs, _g, _g2, _g3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2124",
    "data-name": "Group 2124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 245.488,
    height: 223,
    viewBox: "0 0 245.488 223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2699",
    "data-name": "Rectangle 2699",
    width: 245.488,
    height: 223,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2678",
    "data-name": "Rectangle 2678",
    width: 80.975,
    height: 111.034,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2679",
    "data-name": "Rectangle 2679",
    width: 80.975,
    height: 154.617,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2680",
    "data-name": "Rectangle 2680",
    width: 80.974,
    height: 190.602,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2691",
    "data-name": "Rectangle 2691",
    width: 23.967,
    height: 111.804,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2693",
    "data-name": "Rectangle 2693",
    width: 23.967,
    height: 154.944,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2695",
    "data-name": "Rectangle 2695",
    width: 23.967,
    height: 190.927,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2697",
    "data-name": "Rectangle 2697",
    width: 23.968,
    height: 222.713,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2123",
    "data-name": "Group 2123",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2108",
    "data-name": "Group 2108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2107",
    "data-name": "Group 2107",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2100",
    "data-name": "Group 2100",
    transform: "translate(46.842 111.64)",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2099",
    "data-name": "Group 2099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2098",
    "data-name": "Group 2098",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6494",
    "data-name": "Path 6494",
    d: "M84.137,200.528,165.112,281.5v30.06H84.137Z",
    transform: "translate(-84.137 -200.528)",
    fill: "#f6e497"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2103",
    "data-name": "Group 2103",
    transform: "translate(106.69 68.056)",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2102",
    "data-name": "Group 2102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2101",
    "data-name": "Group 2101",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6495",
    "data-name": "Path 6495",
    d: "M191.637,122.243l80.975,80.974v73.643H191.637Z",
    transform: "translate(-191.637 -122.243)",
    fill: "#f6e497"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2106",
    "data-name": "Group 2106",
    transform: "translate(164.514 32.073)",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2105",
    "data-name": "Group 2105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2104",
    "data-name": "Group 2104",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6496",
    "data-name": "Path 6496",
    d: "M295.5,57.609l80.974,80.974V248.211H295.5Z",
    transform: "translate(-295.5 -57.609)",
    fill: "#f6e497"
  }))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2682",
    "data-name": "Rectangle 2682",
    width: 47.934,
    height: 111.864,
    transform: "translate(0 111.081)",
    fill: "#e6694a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2683",
    "data-name": "Rectangle 2683",
    width: 47.934,
    height: 17.352,
    transform: "translate(0 111.081)",
    fill: "#ea5639"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2684",
    "data-name": "Rectangle 2684",
    width: 47.934,
    height: 154.887,
    transform: "translate(58.756 68.057)",
    fill: "#e6694a"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2685",
    "data-name": "Rectangle 2685",
    width: 47.934,
    height: 17.353,
    transform: "translate(58.756 68.056)",
    fill: "#ea5639"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2686",
    "data-name": "Rectangle 2686",
    width: 47.934,
    height: 222.944,
    transform: "translate(176.269)",
    fill: "#e6694a"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2687",
    "data-name": "Rectangle 2687",
    width: 47.934,
    height: 17.353,
    transform: "translate(176.269 0.171)",
    fill: "#ea5639"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2688",
    "data-name": "Rectangle 2688",
    width: 47.933,
    height: 190.872,
    transform: "translate(117.512 32.073)",
    fill: "#e6694a"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    width: 47.934,
    height: 17.352,
    transform: "translate(117.512 32.073)",
    fill: "#ea5639"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2122",
    "data-name": "Group 2122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2121",
    "data-name": "Group 2121",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2111",
    "data-name": "Group 2111",
    transform: "translate(0 111.081)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2110",
    "data-name": "Group 2110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2109",
    "data-name": "Group 2109",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2690",
    "data-name": "Rectangle 2690",
    width: 23.967,
    height: 111.804,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2114",
    "data-name": "Group 2114",
    transform: "translate(58.756 68.056)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2113",
    "data-name": "Group 2113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2112",
    "data-name": "Group 2112",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2692",
    "data-name": "Rectangle 2692",
    width: 23.967,
    height: 154.944,
    transform: "translate(-0.001)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2117",
    "data-name": "Group 2117",
    transform: "translate(117.512 32.073)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2116",
    "data-name": "Group 2116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2115",
    "data-name": "Group 2115",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2694",
    "data-name": "Rectangle 2694",
    width: 23.967,
    height: 190.927,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2120",
    "data-name": "Group 2120",
    transform: "translate(176.268 0.172)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2119",
    "data-name": "Group 2119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2118",
    "data-name": "Group 2118",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2696",
    "data-name": "Rectangle 2696",
    width: 23.968,
    height: 222.713,
    fill: "#fff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSDashboard);
export default __webpack_public_path__ + "static/media/S_dashboard.a03636c2c9d36b039e81c9b4dceb36bf.svg";
export { ForwardRef as ReactComponent };